import React, { useState, useEffect } from 'react';
import { 
  MessageCircle, 
  Send, 
  ChevronDown, 
  ChevronUp, 
  LifeBuoy, 
  ShieldCheck, 
  Zap 
} from 'lucide-react';
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import Swal from 'sweetalert2';
import './Service.css';

const Service = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [activeInfo, setActiveInfo] = useState(null);
  const [tgLink, setTgLink] = useState('#');

  // Database se Telegram link fetch karne ke liye
  useEffect(() => {
    const configRef = ref(db, 'adminConfig');
    onValue(configRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.telegram) {
        setTgLink(data.telegram);
      }
    });
  }, []);

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Coming Soon',
      text: 'WhatsApp will be added in the next update.',
      icon: 'info',
      confirmButtonColor: '#f3ba2f'
    });
  };

  const faqs = [
    {
      question: "HOW TO DEPOSIT FUNDS INTO YOUR ACCOUNT?",
      answer: "To start trading, you need to deposit assets. Navigate to the 'Home' or 'Wallet' dashboard and select the 'Deposit' option. Choose your preferred cryptocurrency (e.g., USDT, BTC, or ETH). You will be provided with a unique wallet address and a QR code. Copy the address exactly and paste it into the withdrawal section of your external wallet or exchange. Ensure you use the correct network (TRC20, ERC20, or BEP20) to avoid loss of funds."
    },
    {
      question: "HOW LONG DOES THE WITHDRAWAL PROCESS TAKE?",
      answer: "Typically, withdrawals are processed within 5 to 30 minutes. However, the exact time depends on the traffic of the blockchain network. Our system performs an automated security check on every withdrawal to ensure account safety. If you don't receive funds within 2 hours, please contact our support team immediately."
    },
    {
      question: "IS MY ACCOUNT AND ASSET COMPLETELY SECURE?",
      answer: "Security is our top priority. 98% of user assets are stored in offline 'Cold Wallets', making them immune to online hacking. We use multi-signature technology and end-to-end encryption. Your personal data is protected under SSL encryption. We highly recommend enabling Two-Factor Authentication (2FA) in your settings."
    },
    {
      question: "WHAT ARE THE TRADING AND TRANSACTION FEES?",
      answer: "Our fee structure is transparent. Standard spot trading fees start at 0.1% per trade. Deposits are always free. For withdrawals, a small network fee is applied, which goes directly to the blockchain miners. You can see the exact network fee on the withdrawal page before you confirm your transaction."
    }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const toggleInfo = (type) => {
    setActiveInfo(activeInfo === type ? null : type);
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h1>Support Center</h1>
        <p>We are here to help you 24/7</p>
      </div>

      <div className="support-cards">
        <div className={`s-card ${activeInfo === 'security' ? 'active' : ''}`} onClick={() => toggleInfo('security')}>
          <ShieldCheck size={28} color="#f3ba2f" />
          <span>SECURITY</span>
        </div>
        <div className={`s-card ${activeInfo === 'guide' ? 'active' : ''}`} onClick={() => toggleInfo('guide')}>
          <LifeBuoy size={28} color="#f3ba2f" />
          <span>GUIDE</span>
        </div>
        <div className={`s-card ${activeInfo === 'status' ? 'active' : ''}`} onClick={() => toggleInfo('status')}>
          <Zap size={28} color="#f3ba2f" />
          <span>STATUS</span>
        </div>
      </div>

      {activeInfo && (
        <div className="info-detail-box">
          {activeInfo === 'security' && (
            <p><b>SECURITY PROTOCOLS:</b> Your assets are protected by military-grade encryption. We use decentralized cold storage to keep 98% of funds offline. Every login and withdrawal is monitored by our AI-risk system to prevent unauthorized access.</p>
          )}
          {activeInfo === 'guide' && (
            <p><b>TRADING GUIDE:</b> To trade, select a coin from 'Market Trends'. Analyzing the 24h change helps in making decisions. Use the 'Investment' tab to buy. We recommend starting with USDT pairs for stability.</p>
          )}
          {activeInfo === 'status' && (
            <p><b>SYSTEM STATUS:</b> All systems are operational. Deposit and Withdrawal channels for TRC20 and ERC20 are working at 100% capacity with average confirmation times of 2 minutes.</p>
          )}
        </div>
      )}

      <div className="faq-section">
        <h3 className="section-title">COMMON QUESTIONS</h3>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeFaq === index ? 'active' : ''}`} onClick={() => toggleFaq(index)}>
              <div className="faq-question">
                <span>{faq.question}</span>
                {activeFaq === index ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
              </div>
              {activeFaq === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="contact-section">
        <h3 className="section-title">DIRECT CONTACT</h3>
        <div className="contact-grid">
          <a href="#" className="contact-btn whatsapp" onClick={handleWhatsAppClick}>
            <MessageCircle size={20} />
            <span>WhatsApp Support</span>
          </a>
          <a href={tgLink} target="_blank" rel="noopener noreferrer" className="contact-btn telegram">
            <Send size={20} />
            <span>Telegram Channel</span>
          </a>
        </div>
      </div>
      
      <div className="bottom-spacer"></div>
    </div>
  );
};

export default Service;